<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Tutorials'}">
              <h4 class="ms-2">
                {{label.pages.supportAndTutorial}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
              nav-class="tab-title"
              active-nav-item-class="tab-title-active"
              fill
              justified
              pills
          >
            <!-- Page -->
            <b-tab active>
              <template #title>
                {{label.pages.manageSupportPage}}
              </template>
              <b-row class="tab-content">
                <b-col cols="6" class="align-self-center py-0">
                  <b-row class="my-4">
                    <b-col class="align-self-center" cols="3">
                      <label for="title" class="ps_label">
                        {{label.pages.title}}
                        <span class="ps_label_star">*</span>
                      </label>
                    </b-col>
                    <b-col class="align-self-center" cols="9">
                      <b-form-input id="title" size="md" v-model="form.title"/>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6" class="align-self-center py-0">
                  <b-row class="my-4">
                    <b-col class="text-start" cols="3">
                      <label for="headline" class="ps_label">
                      {{label.pages.headline}}
                      </label>
                    </b-col>
                    <b-col class="align-self-center" cols="9">
                      <b-form-input id="headline" size="md" v-model="form.headline"/>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="5" class="align-self-center py-0">
                  <b-row class="my-4">
                    <b-col class="align-self-center" cols="3">
                      <label for="link" class="ps_label">
                        {{label.pages.link}}
                      </label>
                    </b-col>
                    <b-col class="align-self-center" cols="9">
                      <b-form-input id="link" size="md" dir="ltr" v-model="form.link"/>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="5">
                  <b-row v-if="dropZoneAction" class="my-4">
                    <b-col>
                      <drop-zone-custom
                          mode="image"
                          :isRequired="true"
                          :add="dropZoneAction"
                          :edit="!dropZoneAction"
                          :editSrc="imageAddress"
                      />
                    </b-col>
                  </b-row>
                  <b-row v-if="!dropZoneAction" class="my-4">
                    <b-col sm="12">
                      <drop-zone-custom
                          mode="image"
                          :isRequired="true"
                          :add="dropZoneAction"
                          :edit="!dropZoneAction"
                          :editSrc="imageAddress"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="2" class="mt-5">
                  <b-row class="mt-5">
                    <b-col>
                      <label for="display" class="ps_label">
                        {{label.form.display}}
                      </label>
                    </b-col>
                    <b-col>
                      <label class="ps-switch">
                        <input id="display" type="checkbox" v-model="form.isActive">
                        <span class="slider round"></span>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-row class="my-4">
                    <b-col cols="2">
                      <label for="shortDescription" class="ps_label">
                        {{label.pages.summary}}
                        <span class="ps_label_star">*</span>
                        <b-icon
                            icon="question-circle-fill"
                            scale="1.2"
                            variant="ps-base"
                            class="me-1 mouse-question"
                            id="supportShortDescGuide"
                        />
                        <b-popover
                          boundary="#app"
                          placement="top"
                          noninteractive
                          triggers="hover"
                          target="supportShortDescGuide"
                          dir="rtl"
                        >
                          {{ label.pages.Description }}
                        </b-popover>
                      </label>
                    </b-col>
                    <b-col cols="10">
                      <b-form-textarea id="shortDescription" size="sm" rows="5" v-model="form.shortDescription"/>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-row class="my-4">
                    <b-col cols="12">
                      <label for="text" class="ps_label">
                         {{label.pages.content}}
                      </label>
                      <DxHtmlEditor v-model="form.text" :height="editorHeight" >
                        <DxMediaResizing :enabled="mediaResize" />
                        <DxImageUpload
                                :tabs="imageUploadType"
                                :file-upload-mode="imageUploadMode"
                        />
                        <DxToolbar :multiline="multilineToolbar">
                          <DxItem :accepted-values="headerValues" name="header" />
                          <DxItem :accepted-values="sizeValues" name="size" />
                          <DxItem :accepted-values="fontValues" name="font" />
                          <DxItem name="separator" />
                          <DxItem
                                  v-for="toolbar in editorToolbar"
                                  :key="toolbar.id"
                                  :name="toolbar.name"
                          />
                        </DxToolbar>
                      </DxHtmlEditor>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="d-flex justify-content-end">
                <button
                    @click="$router.go(-1)"
                    class="ms-2"
                    v-b-tooltip.hover
                    :title="label.buttons.back"
                >
                  <b-icon
                      icon="arrow-right-square-fill"
                      scale="2.5"
                      class="pt-1"
                      variant="ps-secondary-icon"
                  >
                  </b-icon>
                </button>
                <b-button
                    v-if="!loadingBtn"
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                    @click="editSupport"
                >
                  <b-icon icon="check2-circle" class="ms-1"/>
                  {{ label.buttons.recordInfo }}
                </b-button>
                <b-button
                    v-else
                    disabled
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                >
                  <b-spinner small></b-spinner>
                </b-button>
              </div>
            </b-tab>

          <!-- Items Support Details -->
            <b-tab>
              <template #title>
                {{label.pages.itemsSupport}}
              </template>
              <DxDataGrid
                  :show-row-lines="true"
                  :show-column-lines="true"
                  :show-borders="true"
                  :row-alternation-enabled="true"
                  :rtl-enabled="true"
                  :data-source="items"
                  :columns="fields"
                  :remote-operations="true"
                  :column-auto-width="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  column-resizing-mode="widget"
                  :hover-state-enabled="true"
                  :noDataText="checkData"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  key-expr="id"
                  class="ps_Table"
                  :height="dataGridHeight-50"
              >
                <DxSearchPanel
                    :visible="true"
                    :width="240"
                    :placeholder="label.pages.search"
                />
                <template #btnRGroup>
                  <div>
                  </div>
                </template>
                <template #btnGroup>
                  <div>
                    <b-row>
                      <b-col cols="auto" class="px-0 ms-1">
                        <b-button
                            variant="ps-success"
                            class="py-1 pb-2"
                            size="sm"
                            v-b-tooltip.hover
                            :title="label.buttons.add"
                            @click="add"
                        >
                          <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                        </b-button>
                      </b-col>
                      <b-col cols="auto" class="px-0">
                        <b-button
                            variant="ps-secondary"
                            class="py-1 pb-2"
                            size="sm"
                            v-b-tooltip.hover
                            :title="label.buttons.reload"
                            @click="reloadData"
                        >
                          <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <template #radif="{data}">
                  <div>
                    {{ data.rowIndex + 1 }}
                  </div>
                </template>
                <template #image="{data}">
                  <div>
                    <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
                  </div>
                </template>
                <template #actions="{data}">
                  <b-row class="justify-content-center">
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="edit(data.data)"
                          :id="'editBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'editBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.edit }}
                      </b-tooltip>
                    </b-col>
                    <b-col cols="auto" class="px-0">
                      <button
                          @click="delConfirm(data.data)"
                          :id="'deleteBtnTlp-' + data.data.id"
                      >
                        <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                      </button>
                      <b-tooltip
                        boundary="#app"
                        noninteractive
                        triggers="hover"
                        :target="'deleteBtnTlp-' + data.data.id"
                      >
                        {{ label.buttons.delete }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </template>
                <DxLoadPanel :enabled="true"/>
                <DxScrolling mode="virtual"/>
              </DxDataGrid>
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
        dir="rtl"
        v-model="addModal"
        header-bg-variant="ps-success"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.recordNewItem}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addModal=false"
            id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{label.pages.title}}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="newForm.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="description" class="ps_label">
              {{label.form.description}}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea rows="4" id="description" size="sm" v-model="newForm.description"/>
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction2" class="my-3">
          <b-col sm="3">
            <label for="thumb" class="ps_label">{{label.pages.photo}}</label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
                mode="thumb"
                :isRequired="true"
                :add="dropZoneAction2"
                :edit="!dropZoneAction2"
                :editSrc="imageAddress2"
                editText="تصویر"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction2" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
                mode="thumb"
                :isRequired="true"
                :add="dropZoneAction2"
                :edit="!dropZoneAction2"
                :editSrc="imageAddress2"
                editText="تصویر"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addItem"
            >
            {{label.buttons.submitAndUpload}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--  Edit Modal -->
    <b-modal
        dir="rtl"
        v-model="editModal"
        header-bg-variant="ps-warning"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.editItem}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{label.pages.title}}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="newForm.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="description" class="ps_label">{{label.pages.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea rows="4" id="description" size="sm" v-model="newForm.description"/>
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction2" class="my-3">
          <b-col>
            <drop-zone-custom
                mode="thumb"
                :isRequired="true"
                :add="dropZoneAction2"
                :edit="!dropZoneAction2"
                :editSrc="imageAddress2"
                editText="تصویر"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction2" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
                mode="thumb"
                :isRequired="true"
                :add="dropZoneAction2"
                :edit="!dropZoneAction2"
                :editSrc="imageAddress2"
                editText="تصویر"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editItem"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center">
            {{ label.captions.deleteConfirm}}
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteItem"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import { devExtremeEditor } from "@/components/textEditor/devExtremeEditor";
import dropZoneCustom from '@/components/DropZoneCustom'
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'SupportPage',
  mixins: [dataGridMixin, devExtremeEditor],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      label,
      addModal: false,
      editModal: false,
      editTitle: null,
      editId: null,
      delModal: false,
      delTitle: null,
      delId: null,
      imageAddress: null,
      dropZoneAction: true,
      imageAddress2: null,
      dropZoneAction2: true,
      newForm: {
        title: null,
        description: null,
        imageName: null,
      },
      id: null,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          alignment: 'center'
        },
        {
          dataField: 'title',
          caption: 'عنوان',
          dataType: 'string',
          alignment: 'center',
          cssClass: 'fw1'
        },
        {
          cellTemplate: 'image',
          caption: 'تصویر',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          alignment: 'center'
        },
        {
          dataField: 'description',
          caption: 'توضیحات',
          dataType: 'string',
          width: '300',
          alignment: 'center'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          dataType: 'string',
          alignment: 'center'
        },
      ],
      form: {
        title: null,
        headline: null,
        link: null,
        imageName: null,
        shortDescription: null,
        text: null,
        isActive: true,
      }
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
      thumbUrl: 'thumbUrl',
      items: 'baseX/supportDetail',
      support: 'baseX/support',

    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.reloadFields();
        this.reloadData();
      }
    },
    support() {
      this.id = this.support.id
      this.imageAddress = this.support.imageAddress
      this.form = {
        title: this.support.title,
        headline: this.support.headline,
        link: this.support.link,
        imageName: this.support.imageName,
        shortDescription: this.support.shortDescription,
        text: this.support.text,
        isActive: this.support.isActive,
      }
      if (this.support.imageAddress) {
        this.dropZoneAction = false
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.dropZoneAction = false
        this.form.imageName = this.imageUrl[0].fullPath
        this.imageAddress = this.imageUrl[0].fileAddress
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    thumbUrl() {
      if (this.thumbUrl && this.thumbUrl.length > 0) {
        this.dropZoneAction2 = false
        this.newForm.imageName = this.thumbUrl[0].fullPath
        this.imageAddress2 = this.thumbUrl[0].fileAddress
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    editSupport() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.link.indexOf("/") === 0 || this.form.link.indexOf("https") === 0 || this.form.link.indexOf("http") === 0 || this.form.link.indexOf("") === 0) {
        console.log(1)
      } else if (this.form.link.indexOf("/") !== 0) {
        this.form.link = "/" + this.form.link
      }
      if(this.form.title != null && this.form.title !== ''  && this.form.shortDescription != null && this.form.shortDescription !== '') {
        const payload = {
          value: this.form,
          id: this.id,
        }
        this.$store.dispatch('baseX/editSupport', payload);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    add() {
      this.dropZoneAction2 = true;
      this.$store.commit("setUrlsEmpty");
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      this.$store.commit("setLoadingBtn", true);
      if(this.newForm.title != null && this.newForm.title !== '') {
        const payload = {
          value: this.newForm,
          id: this.id,
        }
        this.$store.dispatch('baseX/addItemSupport', payload);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    edit(item) {
      this.dropZoneAction2 = false;
      this.$store.commit("setUrlsEmpty");
      this.editId = item.id;
      this.editTitle = item.title;
      this.newForm = {
        title: item.title,
        description: item.description,
        imageName: item.imageName,
      };
      this.imageAddress2 = item.imageAddress;
      this.editModal = true;
    },
    editItem() {
      this.$store.commit("setLoadingBtn", true);
      if(this.newForm.title != null && this.newForm.title !== '') {
        const payload = {
          id: this.editId,
          value: this.newForm
        }
        this.$store.dispatch('baseX/editItemSupport', payload);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    delConfirm(data) {
      this.delTitle = data.title;
      this.delId = data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteItemSupport', this.delId);
    },
    reloadFields() {
      this.editTitle = null;
      this.editId = null;
      this.delTitle = null;
      this.delId = null;
      this.newForm = {
        title: null,
        description: null,
        imageName: null,
      };
    },
    reloadData() {
      this.$store.dispatch('baseX/getSupportDetail');
    }
  },
  beforeCreate() {
    this.$store.dispatch('baseX/getSupport');
    this.$store.dispatch('baseX/getSupportDetail');
  },
}
</script>
